module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.cssClasses,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled
    }
  }, [(_vm.isWithIconSpecified) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.withIcon))]) : _vm._e(), _vm._v(" "), _vm._t("default", [(_vm.isIconSpecified) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()]), _vm._v(" "), (_vm.spinner) ? _c('ui-spinner', {
    attrs: {
      "singleColor": ""
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6fbb0ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ui/UiButton.vue
// module id = 284
// module chunks = 2